module.exports = __webpack_public_path__ + "static/media/2s_puzzle.311c166d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/2s_puzzle.png
// module id = 2462
// module chunks = 0